/* istanbul ignore file */

import { CmsImageUrls, RetroCreditImages } from '@/models';

export function createCmsImageUrls(cmsBaseUrl: string) {
  return {
    icons: {
      ada: makeImageURLs('icons-and-animations/ada.svg'),
      defaultReward: makeImageURLs('icons-and-animations/rewards/default-reward-gold.svg'),
      defaultRewardChili: makeImageURLs('icons-and-animations/rewards/default-reward-chili.svg'),
      qrCode: makeImageURLs('icons-and-animations/icon-qr-code.svg'),
      pepperBadge: makeImageURLs('icons-and-animations/chipotle-pepper-icon/pepper-medallion.svg'),
      guacModePepperBadge: makeImageURLs('icons-and-animations/rewards/avocado.svg'),
      guacModePepperBadgeSparkle: makeImageURLs('icons-and-animations/rewards/avocado-sparkle.png'),
      guacModeSmall: makeImageURLs('icons-and-animations/rewards/guac-mode-badge-tiny-button-style.svg'),
      pepperSmall: makeImageURLs('icons-and-animations/chipotle-pepper-icon/pepper-small.svg'),
      pepperGeneral: makeImageURLs('icons-and-animations/chipotle-pepper-icon/pepper-general.png'),
      pepperMarkerDK: makeImageURLs('icons-and-animations/digital-kitchen/dk-large.png'),
      pepperMarkerDKFavorite: makeImageURLs('icons-and-animations/digital-kitchen/dk-favorite-large.png'),
      pepperMarkerDKClosed: makeImageURLs('icons-and-animations/digital-kitchen/dk-closed-large.png'),
      pepperSwift: makeImageURLs('icons-and-animations/chipotlane/swift.png'),
      pepperSwiftFavorite: makeImageURLs('icons-and-animations/chipotlane/swift-favorite.png'),
      pepperSwiftClosed: makeImageURLs('icons-and-animations/chipotlane/swift-closed.png'),
      pepperMarkerWalkup: makeImageURLs('icons-and-animations/walkup/walkup-large.png'),
      pepperMarkerWalkupFavorite: makeImageURLs('icons-and-animations/walkup/walkup-favorite-large.png'),
      pepperMarkerWalkupClosed: makeImageURLs('icons-and-animations/walkup/walkup-closed-large.png'),
      addPerson: makeImageURLs('icons-and-animations/buttons/add-person.svg'),
      person: makeImageURLs('icons-and-animations/buttons/person.svg'),
      userOutline: makeImageURLs('icons-and-animations/buttons/user-outline.svg'),
      userOutlineHalo: makeImageURLs('icons-and-animations/buttons/user-outline-halo.svg'),
      userOutlineHaloGuacMode: makeImageURLs('icons-and-animations/buttons/user-outline-halo-guacmode.svg'),
      checkboxChecked: makeImageURLs('icons-and-animations/buttons/checkbox-checked.svg'),
      checkboxUnchecked: makeImageURLs('icons-and-animations/buttons/checkbox-unchecked.svg'),
      bag: makeImageURLs('icons-and-animations/buttons/bag.svg'),
      bagHalo: makeImageURLs('icons-and-animations/buttons/bag-halo.svg'),
      passwordVisibilityVisible: makeImageURLs('icons-and-animations/buttons/password-visibility-visible.svg'),
      passwordVisibilityHidden: makeImageURLs('icons-and-animations/buttons/password-visibility-hidden.svg'),
      heartEmpty: makeImageURLs('icons-and-animations/buttons/heart-empty.svg'),
      heartFilled: makeImageURLs('icons-and-animations/buttons/heart-filled.svg'),
      heartHovered: makeImageURLs('icons-and-animations/buttons/heart-hovered.png'),
      swipeArrows: makeImageURLs('icons-and-animations/buttons/swipe-arrows.png'),
      pepperMarker: makeImageURLs('icons-and-animations/find-a-chipotle/pepper-marker2x.png'),
      pepperMarkerClosed: makeImageURLs('icons-and-animations/find-a-chipotle/pepper-marker-closed2x.png'),
      pepperMarkerFave: makeImageURLs('icons-and-animations/find-a-chipotle/pepper-marker-fave2x.png'),
      pepperMarkerChipotlane: makeImageURLs('icons-and-animations/find-a-chipotle/pepper-marker-chipotlane.png'),
      pepperMarkerChipotlaneFav: makeImageURLs('icons-and-animations/chipotlane/chipotlane-fav.png'),
      pepperMarkerChipotlaneClosed: makeImageURLs('icons-and-animations/chipotlane/chipotlane-closed.png'),
      deliveryMarker: makeImageURLs('icons-and-animations/find-a-chipotle/delivery-marker2x.png'),
      car: makeImageURLs('icons-and-animations/car.svg'),
      carGold: makeImageURLs('icons-and-animations/car-gold.svg'),
      carWhite: makeImageURLs('icons-and-animations/car-white.svg'),
      search: makeImageURLs('icons-and-animations/buttons/search.svg'),
      dots: makeImageURLs('icons-and-animations/buttons/dots.svg'),
      chipotleLocation: makeImageURLs('icons-and-animations/chipotle-pepper-icon/chipotle-location.svg'),
      locationTarget: makeImageURLs('icons-and-animations/buttons/location-target.svg'),
      menuHamburger: makeImageURLs('icons-and-animations/buttons/menu-hamburger.svg'),
      rewardArrow: makeImageURLs('icons-and-animations/buttons/reward-arrow.svg'),
      arrowRight: makeImageURLs('icons-and-animations/buttons/arrow.svg'),
      arrowRightGold: makeImageURLs('icons-and-animations/buttons/arrow-gold.svg'),
      kebabMenu: makeImageURLs('icons-and-animations/buttons/kebab-menu.svg'),
      map: makeImageURLs('icons-and-animations/find-a-chipotle/map.svg'),
      sadFace: makeImageURLs('icons-and-animations/sad-face.svg'),
      directions: makeImageURLs('icons-and-animations/directions.svg'),
      phone: makeImageURLs('icons-and-animations/phone.svg'),
      chevronLeft: makeImageURLs('icons-and-animations/buttons/chevron-left.svg'),
      chevronLeftPlain: makeImageURLs('icons-and-animations/buttons/chevron-left-plain.svg'),
      circlePlus: makeImageURLs('icons-and-animations/buttons/circle-plus.svg'),
      circleMinus: makeImageURLs('icons-and-animations/buttons/circle-minus.svg'),
      checkMarkSelected: makeImageURLs('icons-and-animations/buttons/checked.svg'),
      selectNone: makeImageURLs('icons-and-animations/buttons/no-selection.svg'),
      iosAppButton: makeImageURLs('icons-and-animations/buttons/ios-app-button.png'),
      androidAppButton: makeImageURLs('icons-and-animations/buttons/android-app-button.png'),
      genericBonus: makeImageURLs('icons-and-animations/rewards/generic-bonus@2x.png'),
      bonus15x: makeImageURLs('icons-and-animations/rewards/bonus-1-5-x@2x.png'),
      bonus100pts: makeImageURLs('icons-and-animations/rewards/bonus-100-pts@2x.png'),
      celebrate: makeImageURLs('icons-and-animations/rewards/celebrate.png'),
      refresh: makeImageURLs('icons-and-animations/buttons/refresh-thin.svg'),
      refreshGold: makeImageURLs('icons-and-animations/buttons/refresh-gold.svg'),
      refreshRed: makeImageURLs('icons-and-animations/buttons/refresh-red.svg'),
      rewardEarned: makeImageURLs('icons-and-animations/rewards/reward-earned.svg'),
      ratingStarBrown: makeImageURLs('icons-and-animations/rewards/star-brown.svg'),
      ratingStarLightBrown: makeImageURLs('icons-and-animations/rewards/star-light-brown.svg'),
      ratingStarDark: makeImageURLs('icons-and-animations/rewards/star-dark-active.svg'),
      ratingStarWhite: makeImageURLs('icons-and-animations/rewards/star-white.svg'),
      ratingStarWhiteFilled: makeImageURLs('icons-and-animations/rewards/star-filled-white.svg'),
      ratingStarFilled: makeImageURLs('icons-and-animations/rewards/star-filled.svg'),
      rewardStar: makeImageURLs('icons-and-animations/buttons/reward-star.svg'),
      rewardStarHover: makeImageURLs('icons-and-animations/buttons/reward-star-hover.svg'),
      rewardStarSelected: makeImageURLs('icons-and-animations/buttons/reward-star-selected.svg'),
      info: makeImageURLs('icons-and-animations/buttons/info.svg'),
      infoOrangeBrown: makeImageURLs('icons-and-animations/buttons/info-orange-brown.svg'),
      twitterFilled: makeImageURLs('icons-and-animations/social-icons/twitter-filled.svg'),
      extrasBadgePlaceholder: makeImageURLs('icons-and-animations/rewards/extras-badge-placeholder.png'),
      nutritionFilter: makeImageURLs('pages/nutrition-calculator/nutrition-filter.svg'),
      nutritionFilterHover: makeImageURLs('pages/nutrition-calculator/nutrition-filter-hover.svg'),
      checkedCircle: makeImageURLs('icons-and-animations/buttons/checked-circle.svg'),
      oneTimesCircle: makeImageURLs('icons-and-animations/rewards/one-times-circle.png'),
      addLarge: makeImageURLs('icons-and-animations/buttons/icon-add-large.svg'),
      removeLarge: makeImageURLs('icons-and-animations/buttons/icon-remove-large.svg'),
      chat: makeImageURLs('icons-and-animations/chat.svg'),
    },

    countryFlags: {
      us: makeImageURLs('icons-and-animations/buttons/united-states-flag.png'),
      ca: makeImageURLs('icons-and-animations/buttons/canada-flag.png'),
    } as {
      [key: string]: CmsImageUrls;
    },

    backgrounds: {
      shimmer: makeImageURLs('global-ui/backgrounds/shimmer.svg'),
      shimmerDark: makeImageURLs('global-ui/backgrounds/shimmer-dark.svg'),
      rewardCelebrationBanner: makeImageURLs('global-ui/backgrounds/reward-celebration-banner.png'),
      rewardsDoodles: makeImageURLs('global-ui/backgrounds/rewards-doodles.jpg'),
      foodprint: makeImageURLs('global-ui/backgrounds/foodprint.svg'),
      foodprintDoodles: makeImageURLs('global-ui/backgrounds/foodprint-doodles.svg'),
      foodprintDoodlesDestkop: makeImageURLs('global-ui/backgrounds/foodprint-doodles-desktop.svg'),
      foodprintDoodlesAccountDestkop: makeImageURLs('global-ui/backgrounds/foodprint-doodles-account-desktop.png'),
      foodprintDoodlesAccountMobile: makeImageURLs('global-ui/backgrounds/foodprint-doodles-account-mobile.png'),
      foodprintDoodlesAccountLink: makeImageURLs('global-ui/backgrounds/foodprint-doodles-account-link-halo.png'),
      ingredientsPattern: makeImageURLs('homepage/preconfigured-entrees/pattern-ingredients.svg'),
      slate: makeImageURLs('global-ui/backgrounds/slate.jpg'),
      extrasAchievementSpark: makeImageURLs('global-ui/backgrounds/extras-achievement-spark.png'),
      pointsMultiplier: makeImageURLs('global-ui/backgrounds/multiplier-background.png'),
      pointsEarned: makeImageURLs('global-ui/backgrounds/points-earned-background.png'),
      milestones: makeImageURLs('global-ui/backgrounds/milestones.png'),
    },

    promoBanners: {
      guac: makeImageURLs('promo-banners/Group-2.png'),
      guac500: makeImageURLs('promo-banners/Group-2-p-500.png'),
      guac800: makeImageURLs('promo-banners/Group-2-p-800.png'),
      guac1080: makeImageURLs('promo-banners/Group-2-p-1080.png'),
      burrito: makeImageURLs('promo-banners/NewBurrito-mid-small.png'),
      burrito500: makeImageURLs('promo-banners/NewBurrito-mid-small-p-500.png'),
      burrito800: makeImageURLs('promo-banners/NewBurrito-mid-small-p-800.png'),
      burrito1080: makeImageURLs('promo-banners/NewBurrito-mid-small-p-1080.png'),
      burst: makeImageURLs('promo-banners/burst.svg'),
      drink: makeImageURLs('promo-banners/TRACTOR_RTD_LEMONADE_D_Labeled_A.png'),
      drink500: makeImageURLs('promo-banners/TRACTOR_RTD_LEMONADE_D_Labeled_A-p-500.png'),
      goods: makeImageURLs('promo-banners/goods-lockup.png'),
      goods500: makeImageURLs('promo-banners/goods-lockup-p-500.png'),
      goods800: makeImageURLs('promo-banners/goods-lockup-p-800.png'),
      giving: makeImageURLs('promo-banners/rewards__donation.png'),
      giving500: makeImageURLs('promo-banners/rewards__donation-p-500.png'),
      loyaltyBurrito: makeImageURLs('promo-banners/loyalty-burrito.png'),
      loyaltyBurritoCentered: makeImageURLs('promo-banners/loyalty-burrito-centered.png'),
      phone: makeImageURLs('promo-banners/phone.png'),
    },

    buttons: {
      xDarkBrown: makeImageURLs('icons-and-animations/buttons/dark-brown-x.png'),
      currentLocation: makeImageURLs('icons-and-animations/buttons/current-locator.svg'),
      closeCircle: makeImageURLs('icons-and-animations/buttons/close-circle.svg'),
      closeSmall: makeImageURLs('icons-and-animations/buttons/close-small.svg'),
      shareTwitter: makeImageURLs('icons-and-animations/buttons/button-social-share-twitter.svg'),
      addToAppleWallet: makeImageURLs('icons-and-animations/buttons/add-to-apple-wallet.png'),
      googlePaySaveToPhone: makeImageURLs('icons-and-animations/buttons/google-pay-save-to-phone.png'),
    },

    logos: {
      rewardPepper: makeImageURLs('icons-and-animations/rewards/reward-pepper.svg'),
      pepperWhite: makeImageURLs('icons-and-animations/rewards/pepper-small-white-3x.png'),
      medallion: makeImageURLs('cons-and-animations/chipotle-pepper-icon/cmg-medallion-logo.svg'),
      medallionBag: makeImageURLs('icons-and-animations/rewards/medallion-bag-new.svg'),
      medallionBagOutlined: makeImageURLs('icons-and-animations/rewards/medallion-bag-outlined.svg'),
      medallionPepperOutlined: makeImageURLs('icons-and-animations/rewards/medallion-pepper-outlined.svg'),
      medallionReward: makeImageURLs('icons-and-animations/rewards/medallion-reward.svg'),
      medallionRewardShout: makeImageURLs('icons-and-animations/rewards/medallion-reward-shout.svg'),
      medallionFluted: makeImageURLs('icons-and-animations/rewards/medallion-fluted@2x.png'),
      medallionPepper: makeImageURLs('icons-and-animations/rewards/cmg-medallion-pepper.svg'),
      medallionGoods: makeImageURLs('icons-and-animations/rewards/medallion-bag.svg'),
      medallionGoodsNew: makeImageURLs('icons-and-animations/rewards/medallion-goods-new.svg'),
      medallionGiving: makeImageURLs('icons-and-animations/rewards/medallion-giving.svg'),
      medallionGivingNew: makeImageURLs('icons-and-animations/rewards/medallion-giving-new.svg'),
      medallionScan: makeImageURLs('icons-and-animations/rewards/medallion-scan.svg'),
      medallionScanNew: makeImageURLs('icons-and-animations/rewards/medallion-scan-new.svg'),
      medallionScanRed: makeImageURLs('icons-and-animations/rewards/medallion-scan-red.svg'),
      medallionEat: makeImageURLs('icons-and-animations/rewards/medallion-eat.svg'),
      medallionEatNew: makeImageURLs('icons-and-animations/rewards/medallion-eat-new.svg'),
      medallionExtras: makeImageURLs('icons-and-animations/rewards/medallion-extras.svg'),
      medallionExtrasOutlined: makeImageURLs('icons-and-animations/rewards/medallion-extras-outlined.svg'),
      medallionCelebrate: makeImageURLs('icons-and-animations/rewards/medallion-celebrate.svg'),
      medallionCelebrateNew: makeImageURLs('icons-and-animations/rewards/medallion-celebrate-new.svg'),
      medallionFood: makeImageURLs('icons-and-animations/rewards/medallion-food.svg'),
      medallionBonus: makeImageURLs('icons-and-animations/rewards/medallion-bonus.svg'),
      medallionBonusNew: makeImageURLs('icons-and-animations/rewards/medallion-bonus-new.svg'),
      pepperFill: makeImageURLs('icons-and-animations/chipotle-pepper-icon/cmg-pepper-fill-6.svg'),
      paypalBrand: makeImageURLs('icons-and-animations/payment/paypal-brand.svg'),
      discoverCardLogo: makeImageURLs('icons-and-animations/payment/discover-logo.svg'),
      discoverCardLogoFilled: makeImageURLs('icons-and-animations/payment/discover-logo-filled.png'),
      visaLogo: makeImageURLs('icons-and-animations/payment/visa-logo.svg'),
      visaLogoFilled: makeImageURLs('icons-and-animations/payment/visa-logo-filled.png'),
      amexLogo: makeImageURLs('icons-and-animations/payment/amex-logo.svg'),
      amexLogoFilled: makeImageURLs('icons-and-animations/payment/amex-logo-filled.png'),
      mastercardLogo: makeImageURLs('icons-and-animations/payment/mastercard-logo.svg'),
      mastercardLogoFilled: makeImageURLs('icons-and-animations/payment/mastercard-logo-filled.png'),
      giftCardLogoFilled: makeImageURLs('icons-and-animations/payment/gift-card-logo-filled.png'),
      defaultCardLogo: makeImageURLs('icons-and-animations/payment/defaultcard-logo.png'),
      defaultCardLogoFilled: makeImageURLs('icons-and-animations/payment/defaultcard-logo-filled.png'),
      guacmode2022Medalion: makeImageURLs('icons-and-animations/rewards/guacmode-2022-medallion.svg'),
      unlockGuacmode: makeImageURLs('icons-and-animations/rewards/unlock-guacmode.svg'),
      badgeThreepeat: makeImageURLs('logos/badge-threepeat.png'),
      badgePlanetFriendly: makeImageURLs('icons-and-animations/rewards/badge-planet-friendly.png'),
      badgeFoundingMember: makeImageURLs('icons-and-animations/rewards/badge-founding-member.png'),
    },
    retroCredit: {
      us: {
        receiptZip: makeImageURLs('', 'pages/retro-credit/receipt-zip-desktop-us.jpg', 'pages/retro-credit/receipt-zip-mobile-us.jpg'),
        receiptDate: makeImageURLs('', 'pages/retro-credit/receipt-date-desktop-us.jpg', 'pages/retro-credit/receipt-date-mobile-us.jpg'),
        receiptCheckNumber: makeImageURLs('', 'pages/retro-credit/receipt-check-number-desktop-us.jpg', 'pages/retro-credit/receipt-check-number-mobile-us.jpg'),
        receiptTotal: makeImageURLs('', 'pages/retro-credit/receipt-total-desktop-us.jpg', 'pages/retro-credit/receipt-total-mobile-us.jpg'),
      },
      ca: {
        receiptZip: makeImageURLs('', 'pages/retro-credit/receipt-zip-desktop-ca.jpg', 'pages/retro-credit/receipt-zip-mobile-ca.jpg'),
        receiptDate: makeImageURLs('', 'pages/retro-credit/receipt-date-desktop-ca.jpg', 'pages/retro-credit/receipt-date-mobile-ca.jpg'),
        receiptCheckNumber: makeImageURLs('', 'pages/retro-credit/receipt-check-number-desktop-ca.jpg', 'pages/retro-credit/receipt-check-number-mobile-ca.jpg'),
        receiptTotal: makeImageURLs('', 'pages/retro-credit/receipt-total-desktop-ca.jpg', 'pages/retro-credit/receipt-total-mobile-ca.jpg'),  
      }
    } as {
      [key: string]: RetroCreditImages
    },
    feedback: {
      sadAvocado: makeImageURLs('icons-and-animations/veggie-characters/feedback-sadcado.mp4'),
      mehAvocado: makeImageURLs('icons-and-animations/veggie-characters/feedback-mehcado.mp4'),
      happyAvocado: makeImageURLs('icons-and-animations/veggie-characters/feedback-happycado.mp4'),
    },

    menu: {
      churros: makeImageURLs('desserts/image-desserts-churros-alt.png'),
    },

    nutritionCalculator: {
      heroBanner: makeImageURLs('pages/nutrition-calculator/hero-banner/web-mobile.png'),
      mealSelector: makeImageURLs('pages/nutrition-calculator/meal-selector/web-desktop.png'),
      ingredientsBanner: makeImageURLs('', 'pages/nutrition-calculator/ingredients-banner/web-desktop.png', 'pages/nutrition-calculator/ingredients-banner/web-mobile.png'),
      forRealImage: makeImageURLs('', 'pages/nutrition-calculator/for-real/web-desktop.png', 'pages/nutrition-calculator/for-real/web-mobile.png'),
      realImage: makeImageURLs('', 'pages/nutrition-calculator/real/web-desktop.png', 'pages/nutrition-calculator/real/web-mobile.png'),
    },

    loadingPepper: makeImageURLs('icons-and-animations/chipotle-pepper-icon/loading-pepper.gif'),
    giftCard: makeImageURLs('icons-and-animations/payment/giftcard.jpg'),
    blankGiftCard: makeImageURLs('icons-and-animations/payment/blank-gift-card.svg'),
    blankCreditCard: makeImageURLs('icons-and-animations/payment/blank-credit-card.png'),
    pageNotFound: makeImageURLs('icons-and-animations/pages/error-page/404.png'),
    dancingVeggies: makeImageURLs('icons-and-animations/veggie-characters/dancing-veggies.gif'),
    dancingAvocado: makeImageURLs('icons-and-animations/veggie-characters/dancing-avocado.mp4'),
    lonelyAvocado: makeImageURLs('icons-and-animations/veggie-characters/Meh-Cado.svg'),
    sadAvocado: makeImageURLs('icons-and-animations/veggie-characters/sad-avocado.svg'),
    happyAvocado: makeImageURLs('icons-and-animations/veggie-characters/happy-avocado.svg'),
    walkUpWindow: makeImageURLs('icons-and-animations/pickup-options/walkup-window.png'),
  };

  function makeImageURLs(def: string, desktop?: string, mobile?: string): CmsImageUrls {
    return {
      default: cmsUrl(def),
      desktop: cmsUrl(desktop || ''),
      mobile: cmsUrl(mobile || ''),
    };
  }

  function cmsUrl(relativeUrl: string): string {
    return `${cmsBaseUrl}/content/dam/chipotle/${relativeUrl}`;
  }
}

export function createCmsAnimationUrls(cmsBaseUrl: string) {
  return {
    bag: {
      lottieBackgroundSparklesUrl: 'https://assets8.lottiefiles.com/packages/lf20_xjs89xjm.json',
      lottieIntroSparkUrl:'https://assets2.lottiefiles.com/packages/lf20_ym5i8d2l.json'
    },
    checkout: {
      registerPickup: cmsUrl('icons-and-animations/checkout/pickup-register.gif'),
      shelfPickup: cmsUrl('icons-and-animations/checkout/pickup-shelf.mp4'),

      orderReceived: cmsUrl('icons-and-animations/checkout/delivery-order-received].gif'),
      headedToPickup: cmsUrl('icons-and-animations/checkout/delivery-headed-to-pickup.gif'),
      onTheWay: cmsUrl('icons-and-animations/checkout/delivery-food-on-way.gif'),
      arrivingSoon: cmsUrl('icons-and-animations/checkout/delivery-arriving-soon.gif'),
      chipotlane: cmsUrl('icons-and-animations/checkout/chipotlane-animation-loop-once.mp4'),
    },
  };

  function cmsUrl(relativeUrl: string): string {
    return `${cmsBaseUrl}/content/dam/chipotle/${relativeUrl}`;
  }
}
